import React, { Component } from "react";
import { withApollo } from "react-apollo";
import { Queries, Mutations } from "../../../../../graphql";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Tabs, Spin, Button, Form, Modal } from "antd";
import Container from "../../../../../components/user/Container";
import ModalConfirmForm from "../../../../../components/user/ModalConfirmForm";
//sector
import SecAttachment from "../sector/SecAttachment";
import SecDocDetail from "../sector/SecDocDetail";
import { getToken, urlBenefit } from "../../../../../utils/auth";
import axios from "axios";
import axiosAPI, { urlAttachFile } from "../../../../../config/axiosAPI";
import { apiKeyNews } from "../../../../../utils/apiKey";
import SecDisasterHistory from "../../paymentVictim/sector/SecDisasterHistory";
import { approveStatus } from "../../../../../utils/leave";
import { alertMessage } from "../../../../../utils/message";
import moment from "moment";
import Delegate from "../../../Delegate";
import { getExternalsType } from "worker-loader/dist/utils";

const { TabPane } = Tabs;
class WelfareListPaymentVictim extends Component {
  state = {
    loading: false,
    loadingFullpage: false,
    preLoadOnsubmit: false,
    deletedAttachmentRecord: [],
  };

  handleSubmit = async (e, statusSend) => {
    const { form, match } = this.props;
    const {
      dataAbstain,
      dataProfile,
      dataEmployeeOrg,
      dataWelfare,
      deletedAttachmentRecord,
    } = this.state;

    e.preventDefault();

    form.validateFields(async (err, values) => {
      console.log("xczzxczcz handlesub", values);

      if (err) {
        Modal.error({
          className: "modalFickIcons",
          title:
            statusSend == "reject"
              ? "ไม่อนุมัติการเบิกสวัสดิการไม่สำเร็จ"
              : "อนุมัติการเบิกสวัสดิการไม่สำเร็จ",
          width: "600px",
          content: <h3 className="mt-3">กรุณาระบุข้อมูลให้ครบถ้วน</h3>,
          okText: "ปิด",
          onOk() {},
        });
      } else {
        let ModalFormTextArea = true;
        let ModalFormTextAreaRequie = false;
        let checkModal = false;
        let checkMinAttach = false;
        let checkIsDocument = false;
        let checkIsHouseRegis = false;
        let checkMinTotalCurrentWithdraw = false;
let checkIsDocumentOwner = false;
let checkIsDocumentRenter = false;

        console.log("valuxxxxes", values);

        if (deletedAttachmentRecord) {
          deletedAttachmentRecord.map((valueMap, keys) => {
            valueMap.isDeleted = true;
          });
        }
        console.log(
          "deletedAttachmentRecord after true",
          deletedAttachmentRecord
        );

        if (
          values.totalCurrentWithdraw < 0 || values.totalCurrentWithdraw == 0
        ) {
          checkMinTotalCurrentWithdraw = true;
        }



        if (
          !values.disasterAttachfile ||
          values.disasterAttachfile.length == 0
        ) {
          checkMinAttach = true;
        }

        if (values.disasterAttachfile) {
          const mergeAttach = values.disasterAttachfile.concat(
            deletedAttachmentRecord
          );
          values.disasterAttachfile = mergeAttach;

          values.disasterAttachfile.map((valueReturn, keys) => {
            if (!valueReturn.description || !valueReturn.documentType) {
              values.disasterAttachfile.splice(keys, 1);
            } else {
              valueReturn.sort = keys + 1;
              if (!valueReturn.id) {
                if (!valueReturn.file) {
                  console.log("nofile eiei", valueReturn);
                  checkModal = true;
                } else {
                  delete valueReturn.file;
                  delete valueReturn.filePath;
                }
              }
            }
          });
        }

        console.log(
          "values.disasterAttachfile after merge",
          values.disasterAttachfile
        );

        let valuesAdd = {};
        console.log("dataWelfare handlesub", dataWelfare);

        if (values.disasterDocument) {
          // values.disasterDocument[0].isChangName =
          //   values.disasterDocument[0].isChangeName;
          // delete values.disasterDocument[0].isChangeName;

          if (
            !values.disasterDocument[0].isDisasterRequest ||
            !values.disasterDocument[0].isIdCard ||
            !values.disasterDocument[0].isEmpIdCard ||
            !values.disasterDocument[0].isDamageWarranty ||
            !values.disasterDocument[0].isPhoto
          ) {
            checkIsDocument = true;
          }

          if (values.homeType != "owner" && values.homeType != "renter") {
            if(!values.disasterDocument[0].isResidentWarranty || !values.disasterDocument[0].isHostDoc){
              checkIsDocumentOwner = true;
            }
          }
          else if (values.homeType == "renter") {
            if(!values.disasterDocument[0].isResidentWarranty || !values.disasterDocument[0].isHostDoc || !values.disasterDocument[0].isContractAndIdCard){
              checkIsDocumentRenter = true;
            }
          }
          else if(values.homeType == "owner" && !values.disasterDocument[0].isHouseRegis){
            checkIsHouseRegis = true
          }
        }


        //valuesAdd.payCashDate = dataWelfare?.payCashDate;
        //valuesAdd.approvePaymentDate = dataWelfare?.approvePaymentDate;
       valuesAdd.disasterCondition = values.condition;
        valuesAdd.disasterId = dataWelfare?.id;
        valuesAdd.approveStatus = dataWelfare?.approveStatus;
        //valuesAdd.disasterTypeId = values.disasterTypeId;
        valuesAdd.approveDate = dataWelfare?.approveDate
          ? dataWelfare?.approveDate
          : moment();
          // valuesAdd.documentNo = dataWelfare?.documentNo;  
         // valuesAdd.payCashDate = dataWelfare?.payCashDate;  
        valuesAdd.homeDescription = values.homeDescription ? values.homeDescription : "-";
        valuesAdd.homeNo = values.homeNo.toString();
        // valuesAdd.empCode = "5594825"
        //valuesAdd.isChangName = values.isChangeName;
        valuesAdd.approveDescription = values.ModalNoteApprove;
        valuesAdd.approveAction = statusSend;

        console.log("valuesAdd", valuesAdd);

        //delete values.isOtherPeople;
        //delete values.disasterType;
        delete values.condition;

        //delete values.damageValue; //wait for api updating
        //delete values.ownerName; //wait for api updating


        let valuesSend = {
          ...values,
          ...valuesAdd,
        };

        console.log("valuxxxxes valuesToSend", valuesSend);

        if (checkModal) {
          Modal.error({
            title: "กรุณาอัปโหลดรูปภาพหรือไฟล์",
            className: "custom-modal-error",
            okText: "ตกลง",
          });
          await this.setState({
            preLoadOnsubmit: false,
            loadingFullpage: false,
          });
        } else if (checkMinAttach) {
          Modal.error({
            title: "กรุณาแนบเอกสารอย่างน้อย 1 รายการ",
            className: "custom-modal-error",
            okText: "ตกลง",
          });
          await this.setState({
            preLoadOnsubmit: false,
            loadingFullpage: false,
          });
        }else if (checkMinTotalCurrentWithdraw) {
          Modal.error({
            title: "จำนวนเงินที่เบิกได้จริงต้องมีค่ามากกว่า 0 บาท",
            className: "custom-modal-error",
            okText: "ตกลง",
          });
          await this.setState({
            preLoadOnsubmit: false,
            loadingFullpage: false,
          });
        }  else if (checkIsDocument) {
          Modal.error({
            title:
              "กรุณาเลือกรายการเอกสารแนบให้ครบถ้วน ประกอบด้วย คำขอรับเงินค่าช่วยเหลือประสบภัยพิบัติ , สำเนาบัตรประจำตัวประชาชน , สำเนาบัตรประจำตัวบุคลากร , หนังสือรับรองที่ออกให้โดยส่วนราชการท้องถิ่น , ภาพถ่ายบ้านและทรัพย์สินที่ได้รับความเสียหาย ",
            className: "custom-modal-error",
            okText: "ตกลง",
          });
          await this.setState({
            preLoadOnsubmit: false,
            loadingFullpage: false,
          });
        } else if (checkIsDocumentOwner) {
          Modal.error({
            title:
              "กรุณาเลือกรายการเอกสารแนบให้ครบถ้วน ประกอบด้วย แบบรับรองและยืนยันการพักอาศัยของตัวบุคคลในบ้าน , สำเนาทะเบียนบ้านและสำเนาบัตรประชาชน(ผู้รับรอง)",
            className: "custom-modal-error",
            okText: "ตกลง",
          });
          await this.setState({
            preLoadOnsubmit: false,
            loadingFullpage: false,
          });
        } 
        else if (checkIsDocumentRenter) {
          Modal.error({
            title:
              "กรุณาเลือกรายการเอกสารแนบให้ครบถ้วน ประกอบด้วย แบบรับรองและยืนยันการพักอาศัยของตัวบุคคลในบ้าน , สำเนาทะเบียนบ้านและสำเนาบัตรประชาชน(ผู้รับรอง) ,  สำเนาหลักฐานการเช่าหรือสำเนาหลักฐานการแสดงความเป็นเจ้าของกรรมสิทธิ์ ",
            className: "custom-modal-error",
            okText: "ตกลง",
          });
          await this.setState({
            preLoadOnsubmit: false,
            loadingFullpage: false,
          });
        } 
        else if (checkIsHouseRegis) {
          Modal.error({
            title:
              "กรุณาเลือกรายการสำเนาใบทะเบียนบ้านหากสถานภาพการพักอาศัยเป็นเจ้าบ้าน",
            className: "custom-modal-error",
            okText: "ตกลง",
          });
          await this.setState({
            preLoadOnsubmit: false,
            loadingFullpage: false,
          });
        }else {

          if (statusSend == "reject") {
            ModalFormTextAreaRequie = true;
          }
          let titleModal =
            statusSend == "reject"
              ? "ท่านต้องการไม่อนุมัติรายการเบิกเงินสวัสดิการ?"
              : "ท่านต้องการอนุมัติรายการเบิกเงินสวัสดิการ?";

          await this.showModalFormConfirm(
            valuesSend,
            titleModal,
            "",
            "ตกลง",
            ModalFormTextArea,
            ModalFormTextAreaRequie
          );
        }
      }
    });
  };

  showModalFormConfirm = async (
    values,
    messageShow,
    title,
    textBtnOK,
    ModalFormTextArea,
    ModalFormTextAreaRequie
  ) => {
    const { form, client } = this.props;

    await this.setState({
      ModalConfirmFormTitle: messageShow,
      ModalConfirmFormSubTitle: title,
      ModalConfirmFormShowModal: true,
      ModalConfirmFormBtnOk: textBtnOK,
      ModalConfirmFormBtnCancel: "ยกเลิก",
      ModalConfirmFormValue: values,
      ModalFormTextArea,
      ModalFormTextAreaRequie,
    });
  };

  hideModalConfirm = async () => {
    await this.setState({
      ModalConfirmFormTitle: null,
      ModalConfirmFormSubTitle: null,
      ModalConfirmFormShowModal: false,
      ModalConfirmFormBtnOk: null,
      ModalConfirmFormBtnCancel: null,
      ModalConfirmFormValue: null,
    });
  };

  getDisasterDetailById = async () => {
    const { token } = getToken();
    const { match } = this.props;

    const API_DEVICE_KEY = atob(apiKeyNews());

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
    };
    console.log('match.url.split("/")[5]', match.url.split("/")[5]);
   //  axios
   //    .get(
   //      `https://uat-vtrcapi.redcross.or.th/benefit-api/api/v1/disaster/get_by_id/${
   //        match.url.split("/")[5]
   //      }`,
   //      {},
   //      {
   //        headers: headers,
   //      }
   //    )
   //    .then(async (response) => {
   //      console.log("response.data", response.data.data);
   //      await this.setState({
   //        dataWelfare: response.data.data,
   //        loadingFullpage: false,
   //        //isEdit: response.data.data.approveStatus == "draft" ? true : false,
   //      });
   //    })
   //    .catch((error) => console.error(`Error: ${error}`));
  //  ${urlBenefit()}disaster/get_by_id/${match.url.split("/")[5]}`);
      const DataFetchAPI = await axiosAPI.get(`
      ${urlBenefit()}disaster/get_by_id/${match.url.split("/")[5]}`);
         console.log("DataFetchAPI history", DataFetchAPI);

         if (DataFetchAPI.data.data) {
            await this.setState({
               dataWelfare: DataFetchAPI.data.data,
               loadingFullpage: false,
               //isEdit: response.data.data.approveStatus == "draft" ? true : false,
            });
         } else {
         await this.setState({
            loadingFullpage: false,
         });
      }
  };

  sendToApproves = async (values) => {
    const { rawData, history } = this.props;
    const { dataAbstain, dataProfile, dataEmployeeOrg } = this.state;

    values.approveDescription = values.ModalNoteApprove;
    delete values.isChangeName;
    delete values.ModalNoteApprove;

    console.log("sendToApproves data", values);

    const { token } = getToken();
    const { match } = this.props;
    const API_DEVICE_KEY = atob(apiKeyNews());

    // await this.setState({
    //   loadingFullpage: true,
    // });

    const headers = {
      //"Content-Type": 'multipart/form-data',
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
    };

   //  axios
   //    .post(
   //      `https://uat-vtrcapi.redcross.or.th/benefit-api/api/v1/approveDisaster`,
   //     values,
   //      {
   //        headers: headers,
   //      }
   //    )
   //    .then(async (response) => {
   //      console.log("response", response);
   //      let messageShow =
   //        values.approveAction == "reject"
   //          ? "ไม่อนุมัติรายการเบิกสวัสดิการเรียบร้อย"
   //          : "ทำการอนุมัติรายการเบิกสวัสดิการเรียบร้อย";
   //      alertMessage("success", messageShow);
   //      setTimeout(() => {
   //        window.location.href = "/welfare/welfareApproveList";
   //      }, 2000);
   //    })
   //    .catch((error) => console.error(`Error: ${error}`));

      const DataFetchAPI = await axiosAPI.post(`
         ${urlBenefit()}approveDisaster`,
         values
      );

      console.log("DataFetchAPI history", DataFetchAPI);

      if (DataFetchAPI.data) {
         let messageShow =
            values.approveAction == "reject"
               ? "ไม่อนุมัติรายการเบิกสวัสดิการเรียบร้อย"
               : "ทำการอนุมัติรายการเบิกสวัสดิการเรียบร้อย";
         alertMessage("success", messageShow);
         setTimeout(() => {
            // window.location.href = "/welfare/welfareApproveList";
            history.push(`/welfare/welfareApproveList`)
         }, 2000);
      } else {
         // await this.setState({
         //    loadingFullpage: false,
         // });
      }

    await this.hideModalConfirm();
  };

  deletedAttachment = async (record) => {
    const { deletedAttachmentRecord } = this.state;
    deletedAttachmentRecord.push(record);

    console.log("deletedAttachmentId", deletedAttachmentRecord);
    await this.setState({
      deletedAttachmentRecord,
    });
  };

  async componentDidMount() {
    await this.getDisasterDetailById();
  }

  render() {
    const { match, location = null } = this.props;
    const {
      loadingFullpage,
      preLoadOnsubmit,
      dataWelfare,
      ModalConfirmFormTitle,
      ModalConfirmFormSubTitle,
      ModalConfirmFormShowModal,
      ModalConfirmFormBtnOk,
      ModalConfirmFormBtnCancel,
      ModalConfirmFormValue,
      ModalFormTextArea,
      ModalFormTextAreaRequie,
    } = this.state;
    //const { getFieldDecorator } = this.props.form;

    console.log("isApproveMode pp", location?.state?.isApproveMode);
    return (
      <Container match={match}>
        <div className="breadcrumb-custom pb-3 mb-4">
          <span style={{ fontSize: "18px" }}>
            รายการเบิกเงินสวัสดิการ / ช่วยเหลือประสบภัยพิบัติ / รายละเอียด{" "}
          </span>
        </div>
        <ModalConfirmForm
          title={ModalConfirmFormTitle}
          subtitle={ModalConfirmFormSubTitle}
          showModal={ModalConfirmFormShowModal}
          btnOk={ModalConfirmFormBtnOk}
          btnCancel={ModalConfirmFormBtnCancel}
          submitToSend={this.sendToApproves}
          hideModal={this.hideModalConfirm}
          valueConfirm={ModalConfirmFormValue}
          ModalFormTextArea={ModalFormTextArea}
          ModalFormTextAreaRequie={ModalFormTextAreaRequie}
        />
        <Spin spinning={loadingFullpage} delay={0}>
          <Form ref={this.formRef}>
            <div className="card-container" id="page-profile">
              <div className="px-5 py-1 card-bg-green">
                {console.log(
                  "dataWelfare.approveStatus",
                  dataWelfare?.approveStatus
                )}

              {
                dataWelfare &&

                <Tabs type="card" className="my-4" defaultActiveKey="1">
                  <TabPane
                    tab={"ข้อมูลการเบิกสวัสดิการ"}
                    key="1"
                    className="mb-0"
                  >
                    <SecDocDetail
                      forceRender
                      form={this.props.form}
                      rawData={dataWelfare}
                      isViewOnly={
                        location?.state?.isApproveMode &&
                        dataWelfare?.approveStatus == "pending"
                          ? false
                          : true
                      }
                      isApproveMode={location?.state?.isApproveMode}
                    />
                  </TabPane>
                  <TabPane tab={"เอกสารแนบ"} key="2" className="mb-0" forceRender>
                    <SecAttachment
                      form={this.props.form}
                      rawData={dataWelfare?.disasterAttachFile}
                      rawDataDoc={dataWelfare?.disasterDocument[0]}
                      isViewOnly={
                        location?.state?.isApproveMode &&
                        dataWelfare?.approveStatus == "pending"
                          ? false
                          : true
                      }
                      onChangeDeletedAttachment={this.deletedAttachment}
                      forceRender
                    />
                  </TabPane>
                  <TabPane tab={"ประวัติการดำเนินการ"} key="3" className="mb-0">
                    <SecDisasterHistory
                      forceRender
                      form={this.props.form}
                      rawData={dataWelfare?.disasterHistories}
                      isViewOnly={
                        location?.state?.isApproveMode &&
                        dataWelfare?.approveStatus == "pending"
                          ? false
                          : true
                      }
                    />
                  </TabPane>
                </Tabs>
              }
                
                <div className="mb-4" align="center">
                  <Link
                    to={{
                      pathname: location?.state?.isApproveMode
                        ? "/welfare/welfareApproveList"
                        : "/welfare/welfareList",
                    }}
                  >
                    <Button
                      type="primary"
                      className="mx-2 btn-white-red"
                      disabled={preLoadOnsubmit}
                    >
                      ย้อนกลับ
                    </Button>
                  </Link>
                  {location?.state?.isApproveMode &&
                    dataWelfare?.approveStatus == "pending" && (
                      <>
                        <Button
                          type="primary"
                          className="mx-2 btn-white-red"
                          htmlType="submit"
                          onClick={(e) => {
                            this.handleSubmit(e, "reject");
                          }}
                          disabled={preLoadOnsubmit}
                        >
                          ไม่อนุมัติ
                        </Button>
                        <Button
                          type="primary"
                          className="ml-2 color-white"
                          htmlType="submit"
                          disabled={preLoadOnsubmit}
                          onClick={(e) => {
                            this.handleSubmit(e, "approve");
                          }}
                        >
                          อนุมัติ
                        </Button>
                      </>
                    )}
                </div>
              </div>
            </div>
          </Form>
        </Spin>
      </Container>
    );
  }
}

WelfareListPaymentVictim.defaultProps = {
  autoFocus: false,
};

WelfareListPaymentVictim.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedWelfareListPaymentVictim = Form.create()(WelfareListPaymentVictim);

export default withApollo(WrappedWelfareListPaymentVictim);
